import * as React from 'react';
import { Text } from '@grandvisionhq/elements';
import { isSubscriptionPurchase, SubscriptionDailyIntervalPriceCaption, isSinglePurchase, SinglePurchasePriceCaption } from '@grandvisionhq/fun-products';
import { useIntl } from '@grandvisionhq/state';
import { isNumber } from '@grandvisionhq/utils';
import { useProductDetailContext } from '../../../Context/ProductDetailContext.js';
import { useSolutionsEcommContext } from '../../context/SolutionsEcommContext.js';

/**
 * @deprecated use the SolutionsCTACaption in `fun-products`
 */ const SolutionsCTACaption = ({ selectedQuantity  })=>{
    const { getLabel  } = useIntl();
    const { activeVariant  } = useProductDetailContext();
    const { state  } = useSolutionsEcommContext();
    const { purchaseType , subscriptionPurchaseConfigurations  } = state.configurations;
    const { deliveryInterval  } = subscriptionPurchaseConfigurations;
    const addToCartLabel = getLabel('products.solutions.addToBasket');
    const unitPrice = activeVariant.purchaseTypePrices && activeVariant.purchaseTypePrices[purchaseType];
    var _discountedPrice;
    const calculatedPrice = !!selectedQuantity && unitPrice ? selectedQuantity * ((_discountedPrice = unitPrice.discountedPrice) !== null && _discountedPrice !== void 0 ? _discountedPrice : unitPrice.originalPrice) : undefined;
    if (isSubscriptionPurchase(purchaseType) && isNumber(calculatedPrice) && !!deliveryInterval) {
        return /*#__PURE__*/ React.createElement(Text, {
            component: "span",
            variant: "body-head"
        }, addToCartLabel, /*#__PURE__*/ React.createElement(SubscriptionDailyIntervalPriceCaption, {
            isCentAmount: true,
            price: calculatedPrice,
            priceInterval: deliveryInterval
        }));
    }
    if (isSinglePurchase(purchaseType) && isNumber(calculatedPrice) && selectedQuantity > 1) {
        return /*#__PURE__*/ React.createElement(Text, {
            component: "span",
            variant: "body-head"
        }, addToCartLabel, /*#__PURE__*/ React.createElement(SinglePurchasePriceCaption, {
            isCentAmount: true,
            price: calculatedPrice
        }));
    }
    return /*#__PURE__*/ React.createElement(Text, {
        component: "span",
        variant: "body-head"
    }, addToCartLabel);
};

export { SolutionsCTACaption };
//# sourceMappingURL=SolutionsCTACaption.js.map
